// @flow
const downloadCSV = (fileName: string, dataRows: Array<Array<string>>) => {
  const sanitizeString = str => {
    if (typeof str !== 'string') {
      return '';
    }
    return `"${str.replace(/"/g, '""')}"`;
  };

  const csvContent = dataRows.map(entry => entry.map(sanitizeString).join(',')).join('\n');
  const encodedUri = `data:text/csv;charset=utf-8,${encodeURIComponent(csvContent)}`;
  const csvFileName = fileName;
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', csvFileName);
  link.click();
};

export default downloadCSV;
